import React, { PropTypes, Component } from 'react';

import Container from '../../components/layouts/Container';
import Page from '../../components/layouts/Page';

import { NitroLogo } from 'nitro-components';

class EmptyLayout extends Component {
  goHome = () => {
    this.context.router.push('/');
  };

  render() {
    return (
      <article>
        <div onClick={this.goHome}>
          <NitroLogo title="" />
        </div>
        <Container>
          <Page>{this.props.children}</Page>
        </Container>
      </article>
    );
  }
}

EmptyLayout.contextTypes = {
  router: PropTypes.object
};

EmptyLayout.propTypes = {
  children: PropTypes.object
};

export default EmptyLayout;



// WEBPACK FOOTER //
// ./src/layouts/global/EmptyLayout.js